<template>
  <div class="banner_container">
    <div class="swiper banner_swiper">
      <div class="swiper-wrapper">
        <div v-for="(item, index) in list" :key="index" class="swiper-slide">
          <video v-if="item.thumb.endsWith('mp4')" :src="$baseURL + item?.thumb" autoplay muted></video>
          <img v-else :src="$baseURL + item?.thumb" width="100%" />
        </div>
      </div>
      <div class="swiper-button">
        <div class="swiper-button-prev">
          <i class="iconfont icon-a-Group2"></i>
        </div>

        <div class="swiper-button-next">
          <i class="iconfont icon-a-Group2"></i>
          <svg viewBox="0 0 52 52">
            <circle :style="{
              transition: transition ? `all ${delay / 1000}s linear` : 'none',
              'stroke-dashoffset': dashoffset,
            }" cx="26" cy="26" r="26"></circle>
          </svg>
        </div>
      </div>
    </div>
    <div class="slogen animate__animated animate__fadeInLeft">
      <template v-for="(item, index) in list" :key="index">
        <h1 :class="{ active: active == index }">{{ item.title }}</h1>
        <p :class="{ active: active == index }">{{ item.description }}</p>
        <a :class="{ active: active == index }" :href="item.weblink" class="more iconfont icon-jiantou">MORE</a>
      </template>
      <div class="xia">
        <i class="iconfont icon-a-Group2"></i>
      </div>
    </div>
  </div>
</template>

<script>
import "swiper/swiper.min.css";

export default {
  props: {
    list: {
      type: Array,
    },
  },
  data() {
    return {
      active: 0,
      transition: true,
      dashoffset: 163,
      delay: 4000,
    };
  },
  methods: {
    /* swiper实例化 */
    onSwiper() {
      let that = this;
      new Swiper(".banner_swiper", {
        loop: true,
        speed: 1000,
        autoplay: {
          delay: that.delay,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        on: {
          slideChange() {
            that.active = this.realIndex;
          },
          slideChangeTransitionEnd() {
            /* 进度 */
            if (that.dashoffset == 163) {
              that.dashoffset = 0;
            } else if (that.dashoffset == 0) {
              that.dashoffset = -163;
            } else if (that.dashoffset == -163) {
              that.transition = false;
              that.dashoffset = 163;
              that.transition = true;

              that.dashoffset = 0;
            }
          },
        },
      });
    },
  },
  watch: {
    list() {
      this.$nextTick(() => {
        this.onSwiper();
      });
    },
  },
};
</script>

<style lang="less" scoped>
.banner_container {
  position: relative;

  .swiper {
    .swiper-slide {
      height: 100vh;

      video,
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
      }
    }

    .swiper-button {
      position: absolute;
      right: 10%;
      bottom: 10%;
      z-index: 9;
      display: flex;

      .swiper-button-prev,
      .swiper-button-next {
        border: 1px solid #ffffff99;
        width: 50px;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        margin: 0 10px;
        border-radius: 50%;
        cursor: pointer;

        .iconfont {
          font-size: 25px;
        }
      }

      .swiper-button-prev {
        transform: rotate(90deg);
      }

      .swiper-button-next {
        transform: rotate(-90deg);

        svg {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;

          circle {
            stroke: #fff;
            stroke-width: 2px;
            fill: none;
            stroke-dashoffset: 163;
            stroke-dasharray: 163;
          }
        }
      }
    }
  }

  .slogen {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 9;
    width: 50%;
    height: 100%;
    box-sizing: border-box;
    // background: rgba(0, 73, 152, 0.7);
    color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;

    h1,
    p,
    .more {
      position: absolute;
      right: 10%;
      display: none;

      &.active {
        display: block;
      }
    }

    h1 {
      white-space: nowrap;
      width: 70%;
      font-size: 40px;
      top: 40%;
    }

    p {
      white-space: nowrap;
      width: 70%;
      font-size: 20px;
      top: 50%;
    }

    .more {
      top: 65%;
      right: auto;
      left: 20%;

      &.active {
        display: flex;
      }
    }

    .xia {
      position: absolute;
      left: 20%;
      top: 80%;
      width: 60px;
      height: 60px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      bottom: 10%;
      border: 1px dashed #fff;
      border-radius: 50%;
      animation: op 2s linear infinite;

      .iconfont {
        font-size: 30px;
      }
    }
  }
}

@media (max-width: 1000px) {
  .banner_container .swiper .swiper-slide {
    height: auto;
  }

  .banner_container .slogen h1 {
    font-size: 20px;
  }

  .banner_container .slogen p {
    font-size: 14px;
  }

  .banner_container .slogen .xia {
    display: none;
  }
}

@media (max-width: 750px) {
  .banner_container .slogen {
    background: transparent;

    h1,
    p,
    .more {
      text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.4);
    }

    p,
    .more {
      transform: translateY(10px);
    }
  }

  .banner_container .swiper .swiper-button .swiper-button-prev,
  .banner_container .swiper .swiper-button .swiper-button-next {
    width: 26px;
    height: 26px;
    margin: 0 5px;

    .iconfont {
      font-size: 13px;
    }
  }

  .banner_container .slogen h1 {
    font-size: 17px;
  }
}
</style>